import React from 'react';
import { Button, IconButton, Paper, DialogTitle, DialogContent, DialogActions, TextField, Tooltip, Divider, Checkbox, InputLabel, MenuItem, FormControl, Select, FormControlLabel, Stack, Typography} from '@mui/material';
import { Add, Delete, Edit, Loyalty, QrCode2, ContentCopy } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, C } from '../include';
import _ from 'underscore';
import { HashEncoder } from "./HashEncoder"
import {QRCodeSVG} from 'qrcode.react';



  
  
class EditTicketIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      company_id: this.props.row ? this.props.row.company_id : this.props.user.company_id,
      treatment_id: this.props.row ? this.props.row.treatment_id : -1,      
      training_patient: this.props.row ? this.props.row.training_patient : false,
      price: this.props.row ? this.props.row.price : 'R$ 0,00',
      hash: this.props.row ? this.props.row.hash : HashEncoder.md5(Date.now().toString()),
      active_step: this.props.row ? this.props.row.active_step : 0,
      patient_id: this.props.row ? this.props.row.patient_id : -1,
      ip: this.props.row ? this.props.row.ip : '0.0.0.0',  
      treatment_list: {},
    };
  }


  componentDidMount() {  
    this.setState({ loading: true });
    this.props.api
      .get('/TreatmentsBrief')
      .then((r) => {
        var list = {}
        for(var row in r.treatments){
          list[ r.treatments[row]["id"] ]= r.treatments[row]["name"];          
        }
        this.setState({
          treatment_list: list,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });  
  }
  
  
  handleSubmit = () => {
    if (!this.props.edit) {
      this.props.api
        .post('/Ticket/', { company_id: this.state.company_id, treatment_id: this.state.treatment_id, training_patient: this.state.training_patient, price: this.state.price, hash: this.state.hash, active_step: this.state.active_step })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Ticket criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Ticket/' + this.props.row.id, { id: this.props.row.id, company_id: this.state.company_id, treatment_id: this.state.treatment_id, training_patient: this.state.training_patient, price: this.state.price, hash: this.state.hash, active_step: this.state.active_step, patient_id: this.state.patient_id, ip: this.state.ip })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };


  
  
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Ticket' : 'Adicionar Ticket'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          {(this.props.user.role==="superuser") &&
            <>
              <TextField
                fullWidth
                variant="outlined"
                label="Empresa"
                value={this.state.company_id}
                onChange={(e) => this.setState({ company_id: e.target.value })}
                type="number"
                required
              />
              <D h="1rem" />
            </>
          }
          <FormControl style={{paddingTop: '0.5rem'}} fullWidth>
            <InputLabel id="select-type">Tratamento</InputLabel>
            <Select
              labelId="select-treatment"
              id="select-t"
              value={Object.keys(this.state.treatment_list).length ? this.state.treatment_id : ''}
              label="Tratamento"
              onChange={(e) => this.setState({treatment_id: e.target.value})}
            >
              {Object.keys(this.state.treatment_list).map(key => {
                  return <MenuItem key={key} value={key}>{this.state.treatment_list[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.training_patient} 
              onChange={(e) => this.setState({ training_patient: e.target.checked })} 
            />
          } label="É paciente-modelo" />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Preço"
            value={this.state.price}
            onChange={(e) => this.setState({ price: e.target.value })}
            required
          />
          {this.props.edit &&
          <>
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Chave"
            value={this.state.hash}
            onChange={(e) => this.setState({ hash: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Passo Corrente"
            value={this.state.active_step}
            onChange={(e) => this.setState({ active_step: e.target.value })}
            type="number"
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Paciente"
            value={this.state.patient_id ? this.state.patient_id : -1}
            onChange={(e) => this.setState({ patient_id: e.target.value })}
            type="number"
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="IP"
            value={this.state.ip}
            onChange={(e) => this.setState({ ip: e.target.value })}
          /> 
          </>
          }       
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit" >
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}
















export class ViewTicketIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      treatment_name: '',
      treatment_id: this.props.row ? this.props.row.treatment_id : -1,      
      training_patient: this.props.row ? this.props.row.training_patient : false,
      price: this.props.row ? this.props.row.price : 'R$ 0,00',
      link: C.public_link_for_candidate + this.props.row.hash
    };
  }
  
  
  componentDidMount() {    
    this.setState({ loading: true });
    this.props.api
      .get('/TreatmentsBrief')
      .then((r) => {
        for(var row in r.treatments){
          if(r.treatments[row]["id"] === this.state.treatment_id){
            this.setState({
              treatment_name: r.treatments[row]["name"],
              loading: false,
            });
            return;
          }         
        }
        this.setState({ loading: false, });
      })
      .catch(() => {
        this.setState({ loading: false });
      });  
  }


  copyToClipboard = (textToCopy) => {
    // Navigator clipboard api needs a secure context (needs https)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy);
    } else {//without https
      document.execCommand("copy", true, textToCopy);
    }
  }


  render() {
    return (
      <form>
        <DialogTitle style={{ minWidth: '400px' }}>
          Dados do Ticket de Entrada
        </DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={1} >
            <Loyalty/>
            <Stack>
            <Typography gutterBottom ><strong>Tratamento</strong>: {this.state.treatment_name}</Typography>
            <Typography gutterBottom ><strong>Paciente-Modelo</strong>: {this.state.training_patient ? "Sim" : "Não"}</Typography>
            <Typography gutterBottom ><strong>Valor</strong>: {this.state.price}</Typography>
            <D h="1rem" />
            <Stack direction="row" spacing={1} >
              <Typography gutterBottom >{this.state.link}</Typography>
              <Tooltip title="Copiar Link" arrow>
                <IconButton sx={{ marginLeft: '12px' }} onClick={ () => {this.copyToClipboard(this.state.link)} }>
                  <ContentCopy />
                </IconButton>
              </Tooltip>
            </Stack>
            <D h="1.5rem" />
            <QRCodeSVG value={this.state.link} />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            OK
          </Button>
        </DialogActions>
      </form>
    );
  }
}



















export class TicketIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 60 },
      { field: 'company_id', headerName: 'Empresa', width: 80 },
      { field: 'treatment_id', headerName: 'Tratamento', width: 100 },
      { field: 'active_step', headerName: 'Passo', width: 70 },
      { field: 'hash', headerName: 'Hash', width: 280 },
      { field: 'patient_id', headerName: 'Paciente', width: 90 },
      { field: 'price', headerName: 'Preço', width: 110 },
      { field: 'training_patient', headerName: 'Paciente-Modelo', width: 140 },
      { field: 'ip', headerName: 'IP', width: 110 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Tickets', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.tickets || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  

  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;
    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditTicketIn
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() => {   
                        for (let row of this.state.selectedRows) {
                          this.props.api
                            .delete("/Ticket/" + row.id)
                            .then((r) => {
                               this.props.alert(r.message);
                               this.setState({ selectedRows: [] });
                               this.updateData();
                             })
                             .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                         }                     
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
              {this.state.selectedRows.length === 1 && (
                <>
                  <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
                  <D size="0.5rem" /> 
                  <Tooltip title="Visualizar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ViewTicketIn
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              //this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <QrCode2 />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditTicketIn
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                        user={this.props.user}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
